/** Saved form preview: inline backend styles, no scripts, network or submissions. */
export function formPreviewDoc(html: string): string {
  return `<!doctype html><html><head><meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data:; form-action 'none'; base-uri 'none'">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style>body{margin:0;padding:24px;background:#fff;color:#111;font:16px/1.5 system-ui,-apple-system,"Segoe UI",sans-serif}</style>
</head><body>${html}</body></html>`;
}
